import { render, staticRenderFns } from "./ForumThreadActions.vue?vue&type=template&id=0537f5a5&"
import script from "./ForumThreadActions.vue?vue&type=script&lang=js&"
export * from "./ForumThreadActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports